export const B2B_ORGANIZATION_LIVES_KEY = 'b2b_organization_lives';
